import { Search2Icon } from '@chakra-ui/icons'
import { Box, Button, Center, Heading, SimpleGrid } from '@chakra-ui/react'
import { chakra } from '@chakra-ui/system'
import Link from 'next/link'
import React from 'react'

import { UkiyoePreview } from '@/components/UkiyoePreview'
import { MasterData } from '@/lib/UkiyoeData'

type Props = {
  attribute: string
  value: string
  attributeInfo: MasterData['key']['key']
}

export const ListedAttributeUkiyoes = ({ attribute, value, attributeInfo }: Props) => {
  const imageSize = '128px'

  return (
    <chakra.section mt="8">
      <Heading as="h1" mt="8" fontSize="2xl">
        <Link href="/attributes" prefetch={false}>
          <a>
            <chakra.span color="#f79128" _hover={{ color: '#d95764' }}>
              Attributes
            </chakra.span>
          </a>
        </Link>
        <chakra.span mx="2">/</chakra.span>
        {attribute.toUpperCase()}: {value}
      </Heading>

      <Box mt="8">
        <Heading as="h2" fontSize="xl">
          {attributeInfo.count} Ukiyoe Found
        </Heading>

        <Box mt="4">
          <a
            href={`https://opensea.io/assets/cryptoukiyoe?search[stringTraits][0][name]=${attribute}&search[stringTraits][0][values][0]=${value}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button colorScheme="teal" variant="outline" minW={{ base: 'full', md: '80' }}>
              <Search2Icon />
              <chakra.span ml="2">Check this list on OpenSea</chakra.span>
            </Button>
          </a>
        </Box>

        <Center mt="4">
          <SimpleGrid w="full" columns={[2, 4]} p={2} spacing={2}>
            {attributeInfo.ids?.map((id) => {
              return <UkiyoePreview key={id} id={id} size={imageSize} lazyload={true} />
            })}
          </SimpleGrid>
        </Center>
      </Box>
    </chakra.section>
  )
}
